import { Estimate } from "./estimate";
import { EstimateType } from "./estimate-type";

export class PartEstimate extends Estimate {
    constructor(
        coverageCode: string,
        partNumber: string,
        eta: number,
        price: number,
        quantity: number,
        isOem: boolean,
        description: string,
    ) {
        super(EstimateType.Part);
        
        this.coverageCode = coverageCode;
        this.partNumber = partNumber;
        this.eta = eta;
        this.price = price;
        this.quantity = quantity;
        this.isOem = isOem;
        this.description = description;
    }
    
    public coverageCode: string = "";
    public partNumber: string = "";
    public eta: number = 0;
    public price: number = 0.0;
    public quantity: number = 0;
    public isOem: boolean = false;
    public description: string = "";
    public override get total(): number { return this.price * this.quantity; }
}